<template>
  <div class="my-5">
    <div class="grid">
      <RequestRemainingDurationInput
        :control-duration="controlDuration"
        @duration-changed="(value) => durationEffective = value"
        :is-special-request="isSpecialRequest"
      />
      <div class="col col-12 md:col-6 ">
        {{ $t('appointmentPage.appointments.remainingTime') }}
        <span class="remaining-duration">{{ remainingDurationToScheduleString }}</span>
      </div>
    </div>
    <ProgressBar
      :value="percentageScheduled"
      :show-value="false"
      class="duration-progress"
    />
    <Message
      v-if="errorAppointmentExceedsControlDuration"
      severity="error"
      :closable="false"
    >
      {{ $t('validations.appointment.exceedsControlDuration') }}
    </Message>
  </div>
</template>

<script>
import ProgressBar from 'primevue/progressbar';
import {convertMinsToHrsMinsString} from "@/shared/utils/dateTimeUtils";
import {getTotalAppointmentsDuration} from "@/shared/utils/appointmentSlotUtils";
import Message from "primevue/message";
import RequestRemainingDurationInput from "@/components/appointments/RequestRemainingDurationInput.vue";

export default {
  name: 'RequestRemainingDuration',
  components: {ProgressBar, Message, RequestRemainingDurationInput},
  props: {
    appointments: {
      type: Array,
      required: true
    },
    controlDuration: {
      type: Number,
      required: true
    },
    isSpecialRequest: {
      type: Boolean,
      default: false
    }
  },
  emits: ['durationUpdated'],
  data() {
    return {
      errorAppointmentExceedsControlDuration: false,
      durationEffective: 0,
      controlDurationReceived: 0,
      controlDurationCurrent: 0,
      firstMountedComponent: false,
    }
  },
  computed: {
    totalAppointmentsDuration() {
      return getTotalAppointmentsDuration(this.appointments)
    },
    percentageScheduled() {
      return (this.totalAppointmentsDuration / this.controlDurationCurrent) * 100
    },
    remainingDurationToScheduleString() {
      return convertMinsToHrsMinsString(this.remainingMinToSchedule())
    },
    controlDurationString() {
      return convertMinsToHrsMinsString(this.controlDurationCurrent)
    },
  },
  methods:{
    remainingMinToSchedule() {
      if(this.isSpecialRequest) {
        this.controlDurationCurrent= (this.durationEffective> 0) ? this.durationEffective*60 : this.controlDurationReceived;
      } else {
        this.controlDurationCurrent= this.controlDuration;
      }

      if(this.controlDurationCurrent > 0){
        this.$emit('durationUpdated', this.controlDurationCurrent);
      }
      let remainingMinutes = this.controlDurationCurrent - getTotalAppointmentsDuration(this.appointments);
      this.errorAppointmentExceedsControlDuration = remainingMinutes < 0
      return remainingMinutes
    },
  },
}
</script>

<style lang="scss" scoped>
.remaining-duration {
  color: $pink;
  font-weight: 600;
}

::v-deep(.duration-progress.p-progressbar) {
  .p-progressbar-value {
    background: linear-gradient(to right, $gradient-left, $gradient-right);
  }
}
</style>
